import * as React from "react";
const SvgFiBrandsHtml5 = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M5.081 0H6.16v1.069h.994V0h1.078v3.234H7.153V2.156H6.17v1.078H5.081zm4.575 1.078h-.95V0h2.985v1.078h-.956v2.156H9.656zM12.164 0h1.13l.694 1.139L14.681 0h1.13v3.234h-1.078V1.631l-.755 1.162-.755-1.162v1.603h-1.059zm4.181 0h1.078v2.166h1.528v1.069h-2.606zM3.497 4.716l1.547 17.362L11.986 24l6.97-1.931 1.547-17.353zm3.16 3.548h5.333v2.128h-3l.197 2.18h2.803v2.123H7.237zM12 14.7h2.616l-.248 2.766L12 18.1zm5.625 6.253L12 22.523v-2.198l-4.369-1.22-.3-3.341H9.47l.15 1.702 2.377.636h-.005v2.213l.01-.002 4.35-1.207.585-6.534H12v-2.18h5.128l.197-2.128H12V6.14h6.952z"
    />
    <path
      fill="#151A2D"
      d="M12 12.572h4.936l-.586 6.534L12 20.313V18.1l2.367-.635.249-2.766H12zM17.325 8.264l-.197 2.128H12V8.264zM11.991 8.264v2.128H12V8.264zm0 4.308v2.123H12v-2.123zm.004 5.53-.005.001v2.212l.01-.002v-2.21z"
    />
    <path
      fill="#151A2D"
      d="M11.991 8.264v2.128h5.137l.197-2.128zm0 4.308V14.7h2.625l-.248 2.766-2.368.635-.005.001-.005.001v2.212l.01-.002 4.35-1.207.586-6.534z"
    />
  </svg>
);
export default SvgFiBrandsHtml5;
